<script>

export default {
    props: ['component', 'handler'],
    data() {
        return {
            input: '',
            timeout: null,
            currentValues: [],
            debounce: null
        }
    },
    computed: {
    },
    mounted() {
        this.currentValues = [];

        for (var i in this.component.currents) {

            const key = this.component.currents[i];

            this.currentValues.push(this.component.options[key]);
        }
    },
    watch: {
        "component.currents": function (currents) {

            if (this.debounce) clearTimeout(this.debounce);

            this.debounce = setTimeout(() => {

                this.currentValues = [];

                for (var i in this.component.currents) {

                    const key = this.component.currents[i];

                    this.currentValues.push(this.component.options[key]);
                }
            }, 1000);
        }
    }

} 
</script>
<template>
    <f-field>
        <template v-slot:label>{{ $vt(component.title) }}</template>
        <template v-slot:content>
            <f-select :disabled="component.disabled" :filter-enabled="Object.values(component.options).length > 20" multiple-selection
                :options="component.options" @change="handler.action($event, 'select', [])"
                :selected="component.currents">
            </f-select>
        </template>
        <template v-slot:helper>{{ $vt(component.description) }}</template>
    </f-field>
</template>
<style lang="scss">
.vform17-textfield2 {
    .checkbutton {
        color: var(--statusPositive);
        padding: 0 8px;
        font-size: 24px;
    }
}
</style>